import React, { useState, useEffect } from 'react'

// Importa las funciones de tu BL (ajusta la ruta según tu estructura)
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones'

// Importa el componente visual hijo (el que tiene los estilos y animación)
import { PluckingRooster as PluckingRoosterOverlay } from './Overlays/PluckingRooster'


/**
 * COMPONENTE: PluckingRooster OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * Este componente es el "Cerebro" del Overlay. 
 * 1. Establece la conexión WebSocket como "overlay:plucking_rooster".
 * 2. Escucha los mensajes entrantes.
 * 3. Pasa la información al componente visual <PluckingRoosterOverlay />.
 * ------------------------------------------------------------------
 */
const PluckingRooster = () => {
    
    // --- ESTADOS DE CONEXIÓN Y DATOS ---
    const [messagesData, setMessagesData] = useState(null); // Payload para el hijo
    const [connectionStatus, setConnectionStatus] = useState('idle');
    
    // -------------------------------------------------------------------------
    // EFECTO: FORZAR FONDO TRANSPARENTE
    // -------------------------------------------------------------------------
    useEffect(() => {
        // 1. Guardamos el color original por si acaso (buena práctica)
        const originalBodyStyle = document.body.style.backgroundColor;
        const originalHtmlStyle = document.documentElement.style.backgroundColor;
        const rootElement = document.getElementById('root'); // El contenedor de React

        // 2. Aplicamos la transparencia "a la fuerza"
        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        if (rootElement) {
            rootElement.style.backgroundColor = 'transparent';
        }

        // 3. Cleanup: Cuando este componente se desmonte (cambies de pantalla),
        // restauramos el color original (o lo dejamos vacío para que tome el CSS).
        return () => {
            document.body.style.backgroundColor = originalBodyStyle;
            document.documentElement.style.backgroundColor = originalHtmlStyle;
            if (rootElement) {
                rootElement.style.removeProperty('background-color');
            }
        };
    }, []); // El array vacío asegura que esto corra solo al montar y desmontar

    // Opcional: Si necesitas manejar el modo femenil/varonil aquí también
    // const [isActiveWomensMode, setIsActiveWomensMode] = useState(false); 

    // -------------------------------------------------------------------------
    // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
    // -------------------------------------------------------------------------
    useEffect(() => {
        
        // 1. Definir la función de conexión
        const connect = async () => {
            // Llamamos a la nueva función del BL especificando 'pluckingRooster'
            //'plucking_rooster', 
            await ConnectWebSocketForOverlay(
                'pluckingrooster', 
                (status) => setConnectionStatus(status),
                (msg) => console.log('[Overlay] Toast:', msg) // O tu lógica de toast
            );

            // Asignamos el manejador de mensajes
            SetSocketMessageHandler(handleIncomingMessage);
        };

        // 2. Definir el manejador de mensajes (El "Switch")
        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            // Filtramos solo los mensajes relevantes para PluckingRooster
            // Nota: En el controller C# definimos el type = "plucking_rooster"
            if (message.type.toLowerCase() === 'plucking_rooster') {
                // Pasamos el objeto 'data' completo al hijo
                // data contiene: { action: 'show_lyric', text: '...', ... }
                setMessagesData(message);
            }
        };

        // 3. Ejecutar conexión
        connect();

        // 4. Cleanup al desmontar
        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, []);

    // -------------------------------------------------------------------------
    // RENDERIZADO
    // -------------------------------------------------------------------------
    return (
        <>
            {/* Renderizamos el componente visual pasándole la data del socket.
                Si tuvieras lógica de Modo Femenil, pásala aquí también.
            */}
            <PluckingRoosterOverlay data={messagesData} /> {/* isActiveWomensMode={isActiveWomensMode} */}

            {/* Opcional: Indicador de error de conexión (útil para debug en OBS) */}
            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 2, fontSize: 8 }}>D</div>
            )}
        </>
    );
};

export { PluckingRooster };